import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AddQRCode = () => {
    const [category, setCategory] = useState('');
    const [subCategory, setSubCategory] = useState('');
    const [itemId, setItemId] = useState('');
    const [image, setImage] = useState(null);
    const [qrCode, setQrCode] = useState('');
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch categories from API
        fetch('http://pbhrm.com/api/categories')
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setCategories(data.data);
                }
            });

        // Fetch subcategories from API
        fetch('http://pbhrm.com/api/subcategories')
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setSubCategories(data.data);
                }
            });
    }, []);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
    };

    const handleQrCodeChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setQrCode(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('category', category);
        formData.append('sub_category', subCategory);
        formData.append('item_id', itemId);
        formData.append('image', image);
        formData.append('qr_code', qrCode);

        try {
            const response = await fetch('http://pbhrm.com/api/qrcodes', {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (data.status === 1) {
                alert('QR Code added successfully');
                navigate('/QRCodeList'); // Redirect to the list page
            } else {
                alert('Failed to add QR Code');
            }
        } catch (error) {
            console.error('Error adding QR code:', error);
            alert('Error adding QR code');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add QR Code</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">QR Code Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="category" className="form-label">Category</label>
                                        <select
                                            id="category"
                                            className="form-select"
                                            value={category}
                                            onChange={(e) => setCategory(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((cat) => (
                                                <option key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="subCategory" className="form-label">Sub Category</label>
                                        <select
                                            id="subCategory"
                                            className="form-select"
                                            value={subCategory}
                                            onChange={(e) => setSubCategory(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Sub-Category</option>
                                            {subCategories.map((subCat) => (
                                                <option key={subCat.id} value={subCat.id}>
                                                    {subCat.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="itemId" className="form-label">Item ID</label>
                                        <input
                                            type="text"
                                            id="itemId"
                                            className="form-control"
                                            value={itemId}
                                            onChange={(e) => setItemId(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={handleImageChange}
                                            required
                                        />
                                        {image && <img src={image} alt="Preview" style={{ width: '100px', height: 'auto', marginTop: '10px' }} />}
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="qrCode" className="form-label">QR Code Image</label>
                                        <input
                                            type="file"
                                            id="qrCode"
                                            className="form-control"
                                            onChange={handleQrCodeChange}
                                            required
                                        />
                                        {qrCode && <img src={qrCode} alt="QR Code Preview" style={{ width: '100px', height: 'auto', marginTop: '10px' }} />}
                                    </div>

                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddQRCode;
